module.exports = __webpack_public_path__ + "media/images/info-pro-1c5bdcfc1993fab9a54db7b725a38600.png";